import PDFViewer, { PDF_DIALOG_PAPER_PROPS, PdfDialogFrame } from '@/shared/ui/components/PDFViewer';
import type { BaseDialogProps } from '@/shared/ui/DialogKit';
import { BaseDialog } from '@/shared/ui/DialogKit';

type Props = BaseDialogProps & {
  pdfUrl: string;
};

const PdfDialog = ({ title, pdfUrl, ...props }: Props) => {
  return (
    <BaseDialog {...props} title={title} fullWidth maxWidth={false} PaperProps={PDF_DIALOG_PAPER_PROPS}>
      <PdfDialogFrame>
        <PDFViewer src={pdfUrl} />
      </PdfDialogFrame>
    </BaseDialog>
  );
};

export default PdfDialog;
